import axios from 'axios'
import { get, has } from 'lodash'
import ImageCrud from './ImageCrud.class'

const baseURL = '/api/review/'

export default class Review {
	constructor (init = {}) {
		this.id = null
		this.setDefaultData()

		if (typeof init === 'number') {
			this.id = init
			this.getSingle().then()
		} else {
			this.setDefaultData(init)
		}
	}

	setDefaultData (init = {}) {
		if (!init) return

		this.id = get(init, 'id') ? init.id : null
		this.model_id = get(init, 'model_id') ? init.model_id : null
		this.model_type = get(init, 'model_type') ? init.model_type : ''
		this.name = get(init, 'name') ? init.name : ''
		this.position = get(init, 'position') ? init.position : ''
		this.review = get(init, 'review') ? init.review : ''
		this.published = has(init, 'published') ? init.published : true
		this.photo = get(init, 'photo') ? new ImageCrud(init.photo) : new ImageCrud()
		this.new_photo = null
	}

	get formData () {
		const formData = new FormData()

		formData.append('model_id', this.model_id)
		formData.append('model_type', this.model_type)
		formData.append('name', this.name)
		formData.append('position', this.position)
		formData.append('review', this.review)
		formData.append('published', this.published ? 1 : 0)
		if (this.new_photo) {
			formData.append('photo', this.new_photo)
		}

		return formData
	}

	create () {
		return axios.post(baseURL, this.formData)
	}

	remove () {
		return axios.delete(baseURL + this.id)
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/Review.class.js